import getCookieDomain from "./getCookieDomain";

// eslint-disable-next-line import/prefer-default-export
const deleteCookie = (name: string) => {
  if (typeof document !== undefined && document) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${name}=; domain=${
      window !== undefined ? getCookieDomain(window?.location?.hostname) : ""
    }; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};
export default deleteCookie;
